module.exports = __webpack_public_path__ + "r-v3/img/clone_mode_11_22_04_on.2549e90e.svg";